import * as Yup from 'yup';

interface IErrors {
  required: string,
}

function validationSchema(errors: IErrors) {
  return Yup.object().shape({
    field: Yup.number()
      .typeError(errors.required)
      .required(errors.required),
  });
}

function validationSchemaNotRequired(errors: IErrors) {
  return Yup.object().shape({
    field: Yup.number()
      .nullable()
      .notRequired(),
  });
}

export const validationRequiredAutocompleteField = (
  val: any,
  errors: IErrors,
  required: boolean = true,
) => {
  const value = { field: !!val ? val.id : null };

  const schema = required ? validationSchema(errors) : validationSchemaNotRequired(errors);

  try {
    schema.validateSync(value, { abortEarly: false });
    return undefined;
  } catch (error: any) {
    return error.inner[0].errors[0];
  }
};
